module.exports = __webpack_public_path__ + "img/C-info-04.84fc257a.png";